export default "<!-- <div class=\"loader\"> -->\n    <div class=\"lds-ellipsis\"><div></div><div></div><div></div><div></div></div>\n<!-- </div> -->\n  "